import styled from "styled-components";

export const LayoutContainer = styled.div`
  padding: 10px 0px 10px 0px;
`;
export const Footer = styled.div``;

export const AppContainer = styled.div`
  width: 100%;
  background: #f7f9fa;
`;
